export const UPLOAD_CONSTANTS = {
  TEMPLATE_NAME: 'plantilla-carga-masiva.csv',
  VALIDATION: {
    SUMMARY_KEY: 'UPLOAD_VALIDATION_SUMMARY',
    FAILED_KEY: 'UPLOAD_VALIDATION_FAILED',
    FAILED_MESSAGE: 'El archivo tiene errores de validacion.'
  }
} as const;
